<template lang="pug">
  .qcw-menu-wrapper
    .qcw-menu-trigger
      i.qcw-icon(style='padding: 0px; padding-left: 8px')
      label(@click='toggleMenu')
        icon(name='ic-assistant' :style="isMenuOpen ? 'color: #27B199;' : 'color: #A0A0A0;'")
    .qcw-menu-popup(v-if='isMenuOpen')
      ul.qcw-menu
        li(v-for='menuItem in menuItems' @click='selectMenuItem(menuItem)' :key='menuItem.id')
          template(v-if="menuItem.id=='separator'")
            span.qcw-menu-separator
              | Generate Ideas
              span.qcw-menu-separator-filler
          template(v-else)
            icon(:name="'ic-'.concat(menuItem.id)")
            span {{ menuItem.label }}
</template>

<script>
import Icon from './../Icon';

export default {
  name: 'AssistantMenu',
  components: {
    Icon,
  },
  props: {
    core: {
      type: Object,
      required: true,
    },
    menu: {
      type: [Object, null],
      required: false,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { id: 'improve-text', label: 'Improve Text' },
        { id: 'lengthen-text', label: 'Lengthen Text' },
        { id: 'shorten-text', label: 'Shorten Text' },
        { id: 'separator' },
        { id: 'ai-generate', label: 'AI Generate' },
        { id: 'knowledge-base', label: 'Knowledge Base Generate' },
      ],
    };
  },
  mounted() {
    document.addEventListener('click', () => {
      if (this.isMenuOpen) {
        this.isMenuOpen = false;
      }
    });
  },
  methods: {
    toggleMenu(event) {
      event.stopPropagation();
      if (this.menu === null) {
        this.isMenuOpen = !this.isMenuOpen;
      }
    },
    selectMenuItem(menuItem) {
      if (menuItem.id !== 'separator') {
        this.$nextTick(() => {
          this.isMenuOpen = false;
          this.$emit('assistant-menu', menuItem);
        });
      }
    },
  },
};
</script>
<style scoped>
.qcw-menu-wrapper {
  position: relative;
  display: flex;
  align-items: flex-end;
}
.qc-icon {
  cursor: pointer;
  margin: 0px;
}

.qcw-menu-popup {
  position: absolute;
  bottom: 100%;
  left: 0;
  z-index: 1;
  background-color: #fff;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 8px 0;
}

.qcw-menu {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.qcw-menu li {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.qcw-menu li:hover {
  background-color: #f5f5f5;
}
.qcw-menu-separator{
  font-size: 9px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.005em;
  text-align: left;
  color: rgba(160, 160, 160, 1);
  width: 100%;
  align-items: center;
  gap: 4px;
  display: flex;
}
.qcw-menu-separator-filler{
  width: 100%;
  height: 1px;
  border-radius: 5px;
  background: rgba(160, 160, 160, 1);
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/ai-assistant/menu.vue